import { ThemeConfig } from "antd";
import { COLOR_PRIMARY_BG, COLOR_SECONDARY_BLUE } from "./colors";

export const antdTheme: ThemeConfig = {
  token: {
    colorBgContainer: COLOR_PRIMARY_BG,
    colorBgBase: COLOR_PRIMARY_BG,
    colorBgElevated: COLOR_PRIMARY_BG,
    colorBgLayout: `linear-gradient(to right, ${COLOR_PRIMARY_BG} 30%, ${COLOR_SECONDARY_BLUE})`,
    colorBgBlur: COLOR_PRIMARY_BG,
    colorPrimaryBg: COLOR_PRIMARY_BG,
    colorText: "#fff"
  },
  components: {
    Menu: {
      itemSelectedBg: "#283583",
      colorText: "#F2F4F7",
      fontSize: 16,
      lineHeight: 24,
      itemBorderRadius: 6,
      itemHeight: 48.8
    },
    Radio: {
      controlItemBgActive: "#283583",
      buttonCheckedBg: "#283583",
      buttonBg: "#0D111C",
      buttonColor: "#CECFD2",
      colorBorderBg: "#262933",
      colorText: "#CECFD2",
      colorBorder: "#262933",
      fontSize: 14
    },
    Input: {
      lineHeight: 2.85,
      controlHeight: 44,
      colorBgContainer: "#0D111C",
      colorBgBase: "#0D111C",
      colorBgElevated: "#0D111C",
      colorBgLayout: "#0D111C",
      colorBgBlur: "#0D111C",
      colorPrimaryBg: "#0D111C",
      colorBorder: "#2F323B",
      hoverBorderColor: "#6A6A6A",
      activeBorderColor: "#6A6A6A",
      colorText: "#EEEEF0",
      colorTextPlaceholder: "#667085",
      borderRadius: 8,
      borderRadiusLG: 8,
      borderRadiusOuter: 8,
      borderRadiusSM: 8,
      borderRadiusXS: 8,
      fontSize: 16,
      colorErrorOutline: "transparent",
      colorTextLabel: "#F4ECEC"
    },
    InputNumber: {
      lineHeight: 2.85,
      controlHeight: 44,
      colorBgContainer: "#0D111C",
      colorBgBase: "#0D111C",
      colorBgElevated: "#0D111C",
      colorBgLayout: "#0D111C",
      colorBgBlur: "#0D111C",
      colorPrimaryBg: "#0D111C",
      colorBorder: "#2F323B",
      hoverBorderColor: "#6A6A6A",
      activeBorderColor: "#6A6A6A",
      colorText: "#EEEEF0",
      colorTextPlaceholder: "#667085",
      borderRadius: 8,
      borderRadiusLG: 8,
      borderRadiusOuter: 8,
      borderRadiusSM: 8,
      borderRadiusXS: 8,
      fontSize: 16,
      colorErrorOutline: "transparent",
      colorTextLabel: "#F4ECEC",
      activeBg: "#0D111C"
    },
    DatePicker: {
      colorBgContainer: "#283583",
      colorBgBase: "#283583",
      colorBgElevated: "#283583",
      colorBgLayout: "#283583",
      colorBgBlur: "#283583",
      colorPrimaryBg: "#283583",
      colorText: "#CECFD2",
      cellHoverBg: "#1A1D38",
      cellHoverWithRangeBg: "#000",
      lineHeight: 2.1
    },
    Button: {
      colorBgContainer: "#E75012"
    },
    Table: {
      headerBg: "#1A1D38",
      borderColor: "#33333D",
      colorBorderBg: "#101223",
      colorPrimary: "#E75012",
      colorText: "#EEEEF0",
      headerColor: "#EEEEF0"
    },
    Pagination: {
      itemActiveBg: "#283583",
      colorPrimaryTextActive: "#fff",
      colorPrimaryText: "#0f0f0f",
      colorText: "#9C9C9C",
      colorPrimary: "#ECECED",
      colorPrimaryTextHover: "#fff",
      colorBorder: "#33333D"
    },
    Form: {
      labelColor: "#F4ECEC",
      verticalLabelMargin: 0,
      verticalLabelPadding: 0
    },
    Select: {
      lineHeight: 2.85,
      controlHeight: 44,
      colorBgContainer: "#0D111C",
      colorBgBase: "#0D111C",
      colorBgElevated: "#0D111C",
      colorBgLayout: "#0D111C",
      colorBgBlur: "#0D111C",
      colorPrimaryBg: "#0D111C",
      colorBorder: "#2F323B",
      colorText: "#EEEEF0",
      colorTextPlaceholder: "#667085",
      borderRadius: 8,
      borderRadiusLG: 8,
      borderRadiusOuter: 8,
      borderRadiusSM: 8,
      borderRadiusXS: 8,
      optionSelectedBg: "#283583",
      optionActiveBg: "#151c2d",
    },
    Typography: {
      colorLink: "#E75012"
    },
    Tooltip: {
      colorBgBase: "#283583",
      colorBgSpotlight: "#283583",
      colorText: "#EEEEF0",
      colorBorder: "#33333D",
    },
    Alert: {
      colorInfoBg: "transparent",
      colorInfoBorder: "#33333D",
      colorIcon: "#E75012",
    }
  }
};
